/**
 * @copyright Copyright 2020 Epic Systems Corporation
 * @file Analytics component
 * @author Mark VanDeWeghe
 */

import { memo } from "react";
import { useSettings } from "../api/use-settings";
import ReactGA from "react-ga";
import { useLocation } from "react-router-dom";

export const Analytics = memo(() => {
	const { analyticsTrackingId } = useSettings();
	const location = useLocation();

	if (analyticsTrackingId !== "") {
		ReactGA.pageview(location.pathname + location.search);
	}

	return null;
});
